import api from '../api'

function buildScopedParams(scope={}) {
  const params = {}
  for (const name of Object.keys(scope)) {
    params[`${name}_id`] = scope[name].id
  }
  return params
}

export default class Connection {

  constructor(baseUrl, scope) {
    this.baseUrl = baseUrl
    this.scope = buildScopedParams(scope)
  }

  url = id => (id ? `${this.baseUrl}/${id}` : this.baseUrl)

  load = (id, params = {}) => api.get(this.url(id), { params: { ...this.scope, ...params } })

  create = data => api.post(this.url(), { ...this.scope, ...data })

  update = data => api.put(this.url(data.id), { ...this.scope, ...data })

  delete = id => api.delete(this.url(id), { params: this.scope })
}



// WEBPACK FOOTER //
// client/stores/connection.js